export default function reportPackageConfigurationDirective() {
  return {
    template: require('./report-package-configuration.html'),
    controller: 'PRReportPackageConfigurationController',
    controllerAs: 'prReportPackageConfigurationVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackage: '=',
    },
  };
}
